module.exports = __webpack_public_path__ + "img/material-active.09874d41.svg";